import isEmpty from 'lodash.isempty';
import { safeWindow } from '../safeWindow';
import { RedirectArgs, SearchParams } from './redirect.type';

const DEFAULT_URL_ORIGIN = 'https://beesafe.pl';

export const encodeUrlSearchParams = (searchParams: SearchParams): string => (
  Object.entries(searchParams)
    .reduce((result, [searchParamName, searchParamValue]) => {
      const encodedSearchParamValue = encodeURIComponent(searchParamValue);
      const searchParam = `${searchParamName}=${encodedSearchParamValue}`;

      return result ? `${result}&${searchParam}` : searchParam;
    }, '')
);

export const getCurrentOrigin = () => safeWindow().location?.origin ?? DEFAULT_URL_ORIGIN;

export const hasHTTPProtocol = (url: string): boolean => {
  const allowedProtocols = ['http:', 'https:'] as const;

  return allowedProtocols.some((protocol) => url.startsWith(protocol));
};

export const redirect = ({ url, searchParams }: RedirectArgs): void => {
  const currentOrigin = getCurrentOrigin();
  const origin = hasHTTPProtocol(url) ? '' : currentOrigin;
  const baseRedirectURL = `${origin}${url}`;
  const redirectURL = isEmpty(searchParams)
    ? baseRedirectURL
    : `${baseRedirectURL}?${encodeUrlSearchParams(searchParams!)}`;

  safeWindow()?.location?.assign(redirectURL);
};
